<!--教科研-->
<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--标签页：课题引领/教研赛事/专题活动/成果展示-->
            <div class="tab-row">
                <teach-research-menu :item-num="activeItem"
                                     @change-item="changeItem"/>
            </div>
            <div class="module-content">
                <!--课题引领-->
                <page-topic v-if="activeItem==='1'"
                            :course-mode="activeMode"
                            :filter-item="activeChildItem"
                            @change-mode="changeMode"/>
                <!--教研赛事-->
                <page-race v-if="activeItem==='2'"
                           :key="'race-' + activeChildItem"
                           :course-mode="activeMode"
                           :filter-item="activeChildItem"
                           @change-mode="changeMode"/>
                <!--专题活动-->
                <page-activity v-if="activeItem==='3'"
                               :key="'activity-' + activeChildItem"
                               :course-mode="activeMode"
                               :filter-item="activeChildItem"
                               @change-mode="changeMode"/>
                <!--成果展示-->
                <page-achieve v-if="activeItem==='4'"
                              :course-mode="activeMode"
                              @change-mode="changeMode"/>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import dataEmpty from "@/components/dataEmpty.vue";
import teachResearchMenu from "@/components/teachResearch/teachResearchMenu.vue";
import pageTopic from "@/components/teachResearch/pageTopic.vue";
import pageRace from "@/components/teachResearch/pageRace.vue";
import pageActivity from "@/components/teachResearch/pageActivity.vue";
import pageAchieve from "@/components/teachResearch/pageAchieve.vue";
export default {
    components: {
        dataEmpty,
        homeHead,
        teachResearchMenu,
        pageTopic,
        pageRace,
        pageActivity,
        pageAchieve
    },
    name: "homeTeachResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeTeachResearch",
            activeItem:"1",
            activeChildItem:"0",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {
        this.$refs.homeHead.activePath = this.activePath;
        if (this.$store.state.params.jumpParams.activeItem){
            this.activeItem = this.$store.state.params.jumpParams.activeItem;
        }
    },
    methods: {
        changeItem(item,childItem){
            this.activeItem = item;
            this.activeChildItem = childItem;
            this.activeMode = this.pageMode;
            this.$store.commit("params/setJumpParams", {});
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
</style>
